module.exports = __webpack_public_path__ + "static/ubuntu-medium-d4ee1476ddc3dedb306bbd3b7ad6501b.ttf";